<i18n>
  {
    "en": {
      "errorTitle": "Page not found",
      "errorMessage": "We could not find the page you are looking for" ,
      "goBackHomeMessage": "Go back home page"
    },
    "es": {
      "errorTitle": "Página no encontrada",
      "errorMessage": "No hemos podido encontrar la página que busca",
      "goBackHomeMessage": "Volver a la página de inicio"
    }
  }
</i18n>

<template>
  <v-container
    class="error-page"
    fill-height
    fluid
    style="height: calc(100vh - 58px);"
  >
    <v-row justify="center" align="center">
      <v-col cols="12" sm="8" md="4">
        <v-card style="text-align:center;">
          <v-toolbar color="primary" dark flat>
              <v-img :src="require('@dynameat/assets/images/dynameat-logo-long.png')"
                     alt="DynamEat name" contain height="30" />
          </v-toolbar>
          <h1>{{$t('errorTitle')}}</h1>
          <p>{{$t('errorMessage')}}</p>
          <v-btn :to="`/`" color="primary" outlined>
            {{$t('goBackHomeMessage')}}
          </v-btn>
          <v-breadcrumbs/>
        </v-card>
        <MadeWithLove class="pt-5"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MadeWithLove from '@ulibs/unlogin/components/MadeWithLove.vue';

export default {
  name: 'not-found-page',
  components: { MadeWithLove }
};
</script>

<style scoped>
  .error-page {
    background: linear-gradient(0deg, rgba(255, 255, 255, 1) 0%, var(--v-primary-lighten3) 100%);
  }
</style>
